//--- MAIN --- //
$(function () {
    $("#body").css("overflow","hidden").wrap('<div class="scroll-wrapper"><div class="scrollbar-macosx"><div id="inner"></div></div></div>');
    $('.scrollbar-macosx').scrollbar();
    $("#body").prepend('<button id="bg"></button>');

    // SCROLL
    $(".hp-visual-content .main-heading").on("click", function (e) {
        e.preventDefault(e);
        if ($("body").css("overflow") == "hidden") {
            $('.scrollbar-macosx').animate({
                scrollTop: $("#hp-visual").next("*").offset().top - 30
            }, 500);
        } else {
            $('html,body').animate({
                scrollTop: $("#hp-visual").next("*").offset().top - 30
            }, 500);
        }
    });

    // BOOKING
    $("#booking > .btn").on("click", function (e) {
        $(this).toggleClass("active").find("i").toggle(0).parent().next("form").fadeToggle(500);
    });

    var lang = $("html").attr('lang');
    var start_date = $("#form-arrival");
    var end_date = $("#form-departure");

    function checkDateStart()
    {
        var date = new Date(start_date.val());
        date.setDate(date.getDate()+1);
        return date.dateFormat('Y-m-d');
    }
    function checkDateEnd()
    {
        var date = new Date(end_date.val());
        date.setDate(date.getDate()-1);
        return date.dateFormat('Y-m-d');
    }

    start_date.datetimepicker({
        lang: lang,
        timepicker: false,
        scrollMonth: false,
        format:'Y-m-d',
        minDate:'-1970/01/01',
        closeOnDateSelect: true,
        scrollInput: false,
        onChangeDateTime: function (currentDateTime) {
            var date = new Date(start_date.val());
            date.setDate(date.getDate() + 1);
            end_date.val(date.dateFormat('Y-m-d'));
        }
    });
    start_date.prev(".icon").on("click", function () {
        $(this).next(".date").datetimepicker('show');
    });

    end_date.datetimepicker({
        lang: lang,
        timepicker: false,
        scrollMonth: false,
        format:'Y-m-d',
        minDate:'-1970/01/01',
        closeOnDateSelect: true,
        scrollInput: false,
        onShow: function (ct) {
            if (start_date.val()) {
                this.setOptions({
                    minDate: checkDateStart(), formatDate: 'Y-m-d'
                })
            }
        }
    });
    end_date.prev(".icon").on("click", function () {
        $(this).next(".date").datetimepicker('show');
    });



    // CONTACT SUBMIT FORM
    $(document).on('click', '#submitAjaxForm', function (e) {
        $('html, body').animate({
            scrollTop: $("#f-contact").offset().top - 65
        }, 500);
        e.preventDefault();
        var $form = $(this).closest('form');
        $form.find('[name]').parents('div').removeClass('error');
        $form.find('.status .good,.status .bad').addClass("hide");
        $.ajax({
            type: 'POST',
            data: $form.serialize(),
            dataType: 'json'
        }).done(function (data) {
            if (!data.noerror) {
                $form.find('.status .bad').removeClass("hide");
            } else {
                $form.find('.status .good').removeClass("hide");
                $form[0].reset();
            }
            for (var key in data.errors) {
                if(!data.errors.key) {
                    $form.find('[name="' + key + '"]').parents('div').addClass('error');
                }
            }
        });
    });

    // HIDE GALLERY CONTROL
    $(document).on('click', '.spo-gallery-control .close', function (e) {
        e.preventDefault();
        $(this).toggleClass("icon-chevron-small-down").toggleClass("icon-chevron-small-up");
        $(".spo-gallery-control").toggleClass('is-hidden');
    });

    // NEWSLETTER
    $("#validElm1, #existsElm1, #saveElm1, #saveAgree1, #fillName1").hide();
    $("#submitNewsletter1").on("click", function () {
        $("#validElm1, #existsElm1, #saveElm1, #saveAgree1, #fillName1").hide();
        var e = $("#emailNewsletter1").val();
        var n = $("#nameNewsletter1").val();
        if(!$("#f-checkbox").is(':checked')){
            $('#saveAgree1').show();
            $('#checkboxDiv').addClass('error');
        }
        if(e == ''){
            $('#validElm1').show();
            $('#emailNewsletter1').parents('div').addClass('error')
        }else{
            $('#emailNewsletter1').parents('div').removeClass('error')
        }
        if(n == ''){
            $('#fillName1').show();
            $('#nameNewsletter1').parents('div').addClass('error')
        }else{
            $('#nameNewsletter1').parents('div').removeClass('error')
        }
        if($("#f-checkbox").is(':checked') && n!='') {
            return $.ajax({
                type: "POST",
                url: "/www/templates/ajax/ajaxNewsletter.php",
                data: {
                    emailNewsletter: e,
                    nameNewsletter: n,
                    lang: $("html").attr("lang")
                },
                dataType: "json"
            }).done(function (e) {
                0 == e.valid && $("#validElm1").show(), 0 == e.exists && $("#existsElm1").show(), 1 == e.save && ($("#saveElm1").show(), setTimeout(function () {
                    $("#f-checkbox").attr('checked', false),$("#emailNewsletter1").val(""), $("#nameNewsletter1").val(""), $("#saveElm1").hide()
                }, 5000))
            }), !1
        }


    });

    // ANTISPAM CONTACT
    if ($("#f-contact").length) {
        $("#f-contact").append('<input name="antispam" value="antispam" type="hidden" />');
    }

    // HEADER - MENU
    $(document).on('click', '#main-header #logo', function (e) {
        if ($(this).find(".icon-menu").css("display") == "inline-block") {
            e.preventDefault();
            $("body").toggleClass("no-scroll");
            $("#bg").fadeToggle(300);
            $(this).parents("#main-header").find(".header-nav").fadeToggle(300).toggleClass("toggle");
        }
    });

    // HEADER - MENU CLOSE
    $(document).on('click', '#main-header .icon-close, #bg', function () {
        $("body").toggleClass("no-scroll");
        $("#bg").fadeToggle(300);
        $("#main-header").find(".header-nav").fadeToggle(300).toggleClass("toggle");
    });

    // OFFER
    $("#hp-offer").on("click", function () {
        $(this).parents(".hp-visual-offer").toggleClass("active");
        if (!$(this).parents(".hp-visual-offer").hasClass("active")) {
            sessionStorage.setItem("offerHide", "true");
        } else {
            sessionStorage.removeItem("offerHide");
        }
    });
    if ($(window).width() > 768 && sessionStorage.getItem("offerHide") == null) {
        setTimeout(function () {$("#hp-offer").trigger('click')}, 2500);
    }

    // LANGS
    $("#lang .list-active .lang").on("click", function () {
        $(this).parent(".list-active").next(".list").toggleClass("active").slideToggle(500);
    });

    // SOCIAL FOOTER
    var social = $("#main-footer .sub-footer .social .icons").html();
    $("#main-footer.spo .footer .social").append(social);

    // MOB NAVIGATION
    if ($("#lang .list").length) {
        var langs = $("#lang .list").html();
        $("#main-header .header-nav .container .nav-langs").append(langs);
    } else {
        $(".nav-langs").remove();
    }

    // MOB ADDRESS
    var address = $("#main-footer .sub-footer .info").html();
    $("#main-header .header-nav .container .nav-address").append(address);

});

//--- PLUGINS --- //
$(function () {
    if ($('.select2').length) {
        $('.select2').select2();
    }
    if ($(window).width() > 480) {
        $('.hp-visual-inner').slick({
            lazyLoad: 'progressive',
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 9000,
            fade: true,
            cssEase: 'linear',
            arrows: false,
            dots: false,
            pauseOnHover: false
        });
        $('.hp-visual-inner').on('beforeChange', function(event, slick, currentSlide, nextSlide){
            $(this).find(".slick-active").next().find("img").addClass("lazyload");
        });
    }

    // GALLERY
    $('.spo-gallery-inner').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 3000,
        fade: true,
        cssEase: 'linear',
        asNavFor: '.spo-gallery-thumbs-inner'
    });
    $('.spo-gallery-inner').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $(this).find(".slick-active").next().find("img").addClass("lazyload");
    });
    $('.spo-gallery-thumbs-inner').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        initialSlide: 1,
        asNavFor: '.spo-gallery-inner',
        dots: false,
        centerMode: true,
        focusOnSelect: true,
        lazyLoad: 'ondemand',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    });
    $('.spo-gallery-thumbs-inner').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $('.spo-gallery-inner').find(".slick-active").find("img").addClass("lazyload");
    });

    // GALLERY - SPO DETAIL
    $('#spo-detail .detail-slider-inner').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 3000,
        fade: true,
        cssEase: 'linear',
        asNavFor: '#spo-detail .detail-slider-thumbs'
    });
    $('#spo-detail .detail-slider-thumbs .inner').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 1,
        asNavFor: '#spo-detail .detail-slider-inner',
        dots: false,
        centerMode: false,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1320,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    });

    // SPO DETAIL SCROLLBAR
    $('#spo-detail .scrollbar-macosx').scrollbar();

    slick_paging();
    function slick_paging() {
        // ROOMS LIST
        var wrapper = $("#spo-rooms .spo-rooms-inner, #spo-offers .spo-offers-inner");
        if ($(".slick-initialized").length) {
            wrapper.slick('unslick');
        }
        wrapper.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: true,
            responsive: [
                {
                    breakpoint: 960,
                    settings: "unslick"
                }
            ]
        });
    }
    $(window).resize(slick_paging);

    // DIRECTORY SLIDER
    $('#top-page .top-page-slider').slick({
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 6000,
        fade: true,
        cssEase: 'linear',
        arrows: false,
        dots: true
    });

    // DIRECTORY SLIDER - OFFERS
    $('#bottom-page #offers-slider').slick({
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        fade: true,
        cssEase: 'linear',
        arrows: false,
        dots: true
    });


    // DATEPICKER - AVAILABILITY
    if ($("#f-arrival").length) {

        var lang = $("html").attr('lang');
        var start_date = $("#f-arrival");
        var start_date_alt = $("#f-arrival-alt");
        var end_date = $("#f-departure");
        var end_date_alt = $("#f-departure-alt");

        function checkDateStart() {
            var date = new Date(start_date.val());
            date.setDate(date.getDate() + 1);
            return date.dateFormat('Y-m-d');
        }

        function checkDateEnd() {
            var date = new Date(end_date.val());
            date.setDate(date.getDate() - 1);
            return date.dateFormat('Y-m-d');
        }

        function getMonthStart() {
            var date = new Date(start_date.val());
            date.setDate(date.getDate());
            return monthsCalendar[date.dateFormat('F')];
        }

        function getMonthEnd() {
            var date = new Date(end_date.val());
            date.setDate(date.getDate());
            return monthsCalendar[date.dateFormat('F')];
        }

        start_date.datetimepicker({
            lang: lang,
            timepicker: false,
            scrollMonth: false,
            format: 'Y-m-d',
            minDate: '-1970/01/01',
            closeOnDateSelect: true,
            todayButton: false,
            defaultSelect: true,
            onShow: function (currentDateTime) {
                if (end_date.val()) {
                    /*this.setOptions({
                     maxDate:checkDateEnd(), formatDate:'Y-m-d'
                     })*/
                }
            },
            onChangeDateTime: function (currentDateTime) {
                start_date_alt.find(".day").text(currentDateTime.getDate());
                start_date_alt.find(".month").text(getMonthStart());

                var date = new Date(start_date.val());
                date.setDate(date.getDate() + 1);
                end_date.val(date.dateFormat('Y-m-d'));

                end_date_alt.find(".day").text(date.getDate());
                end_date_alt.find(".month").text(monthsCalendar[date.dateFormat('F')]);
            }
        });
        start_date_alt.on("click", function () {
            $(this).prev(".date").datetimepicker('show');
        });

        end_date.datetimepicker({
            lang: lang,
            timepicker: false,
            scrollMonth: false,
            format: 'Y-m-d',
            minDate: '-1970/01/01',
            closeOnDateSelect: true,
            todayButton: false,
            defaultSelect: true,
            onShow: function (ct) {
                if (start_date.val()) {
                    this.setOptions({
                        minDate: checkDateStart(), formatDate: 'Y-m-d'
                    })
                }
            },
            onChangeDateTime: function (currentDateTime) {
                end_date_alt.find(".day").text(currentDateTime.getDate());
                end_date_alt.find(".month").text(getMonthEnd());
            }
        });
        end_date_alt.on("click", function () {
            $(this).prev(".date").datetimepicker('show');
        });
    }
    if ($("#bottom-page").length) {
        $("#bottom-page").find(".wsw").lightGallery({
            thumbnail:false,
            selector: '.lg'
        });
    }
});

// --- FUNCTIONS CALLS --- //
$(function () {
    nl_hover_touch_unstick();

    nl_cookie();

    nl_anchor_link();

    nl_footer();

    $(window).resize(nl_check_size);
});

// --- AFTER PAGE LOAD --- //
$(window).load(function(){
    if ($(window).width() > 768) {
        $("#special-offers .nav-special-offers-inner").slick({
            lazyLoad: 'progressive',
            infinite: true,
            arrows: false,
            dots: true
        });
    }

    var $map = $('#google-map');
    if ($map.length) {
        $.getScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyByUFX8onGyNFy-iNHhbuHrWGz40EeceQM")
            .done(function () {
                //--- GOOGLE MAP --- //

                var coords = $map.data('coords').split(/[\s,]+/);

                var mapOptions = {
                    zoom: 15, scrollwheel: false, draggable: false, mapTypeControl: false, center: {
                        lat: parseFloat(coords[0]), lng: parseFloat(coords[1])
                    }
                };

                var map = new google.maps.Map($map[0], mapOptions);

                var marker_s = new google.maps.Marker({
                    position: mapOptions.center, map: map, title: $map.data('title'), icon: '/dist/img/marker-s.png'
                });
                var marker = new google.maps.Marker({
                    title: $map.data('title'), icon: '/dist/img/marker.png'
                });

                google.maps.event.addListener(map, 'click', function () {
                    map.setOptions({
                        scrollwheel: true, draggable: true
                    });
                });
                $('#hp-location .locations [data-gps]').each(function () {
                    var $this = $(this),
                        positionArr = $this.data('gps').split(/[\,\s]+/),
                        position = new google.maps.LatLng(parseFloat(positionArr[0]), parseFloat(positionArr[1])),
                        position_s = new google.maps.LatLng(parseFloat(coords[0]), parseFloat(coords[1]));

                    $this.click(function (e) {
                        e.preventDefault();
                        if ($(this).hasClass('active')) {
                            $(this).removeClass('active');
                            marker.setMap(null);
                            map.panTo(position_s);
                        } else {
                            $("#hp-location .locations [data-gps]").removeClass('active');
                            $(this).addClass('active');
                            map.panTo(position);
                            marker.setMap(map);
                            marker.setPosition(position);
                            marker.setTitle($this.attr("title"));
                        }
                    });
                });
            });
    }
});
